import ClimateChangeIcon from '@assets/images/riskCategories/climateWhite.svg';
import DiseaseIcon from '@assets/images/riskCategories/diseaseWhite.svg';
import EventCancellationIcon from '@assets/images/riskCategories/eventCancellationWhite.svg';
import InteruptedUtilitiesIcon from '@assets/images/riskCategories/interruptedWhite.svg';
import {
  IconDefinition,
  faBacterium,
  faBiohazard,
  faCircle,
  faCloudBolt,
  faFire,
  faHouseChimneyCrack,
  faHouseFloodWater,
  faHurricane,
  faSmog,
  faSunPlantWilt,
  faTemperatureArrowUp,
  faTornado,
  faTruckPlane,
  faVirus,
} from '@fortawesome/free-solid-svg-icons';

export interface ICoverageCategory {
  name: string;
  description?: string;
  cases: ICoverageCase[];
  image?: string;
  path?: string;
}

export interface ICoverageCase {
  case: string;
  description: string;
  icon?: IconDefinition;
  videoLink?: string;
}

export const COVERAGE_CATEGORIES: ICoverageCategory[] = [
  {
    name: 'Interrupted Utilities',
    path: '/interrupted-utilities',
    image: InteruptedUtilitiesIcon,
    description:
      'Property damage, spoiled inventory, emergency supplies, and other hazards due to Interrupted Utilities cost the average small business $5,000 to $50,000+ per event. Most insurance policies exclude protection from utility disruptions like power outages. Centinel’s protection plans for Interrupted Utilities send you a hassle-free payment if you experience a:',
    cases: [
      {
        case: 'Power Outage',
        icon: faCloudBolt,
        description:
          'Cost US businesses >$150 Billion every year. Stay resilient with Centinel’s PowerProtect™.',
        videoLink:
          'https://www.youtube.com/embed/L-K6tEkAjL8?rel=0&amp;autoplay=1',
      },
    ],
  },
  {
    name: 'Climate Change',
    image: ClimateChangeIcon,
    cases: [
      {
        case: 'Flooding',
        icon: faHouseFloodWater,
        description: '100-year flood levels or greater',
      },
      {
        case: 'Hurricane',
        icon: faHurricane,
        description: 'Category 3 storm or greater',
      },
      {
        case: 'Tornado',
        icon: faTornado,
        description: 'Category F3 or greater',
      },
      {
        case: 'Wildfire',
        icon: faFire,
        description: 'High or very high integrated hazard risk',
      },
      {
        case: 'Earthquake',
        icon: faHouseChimneyCrack,
        description: 'Level 8 or greater quake',
      },
      {
        case: 'Drought',
        icon: faSunPlantWilt,
        description: 'D3 or greater intensity',
      },
      {
        case: 'Heat Wave',
        icon: faTemperatureArrowUp,
        description: 'Danger or Extreme Danger on NOAA Index',
      },
      {
        case: 'Air Pollution',
        icon: faSmog,
        description: 'Purple or Maroon levels on AQI',
      },
      {
        case: 'Sinkhole',
        icon: faCircle,
        description: 'Greater than 100 feet in diameter',
      },
    ],
  },
  {
    name: 'Infectious Disease',
    image: DiseaseIcon,
    cases: [
      {
        case: 'Coronavirus',
        icon: faVirus,
        description: 'COVID-19, MERS, MRSA, SARS',
      },
      {
        case: 'Influenza',
        icon: faVirus,
        description: 'H5N1, H7N9',
      },
      {
        case: 'Filoviridae',
        icon: faVirus,
        description: 'Ebola, Marburg',
      },
      {
        case: 'Mosquito-borne',
        icon: faVirus,
        description: 'Malaria, Dengue, Yellow Fever, Zika',
      },
      {
        case: 'Rotavirus',
        icon: faVirus,
        description: 'B, C',
      },
      {
        case: 'Paramyxoviridae',
        icon: faVirus,
        description: 'Nipah, Hendra',
      },
      {
        case: 'Bunyaviridae',
        icon: faVirus,
        description: 'Crimean-Congo, Rift Valley',
      },
      {
        case: 'Bacterial Other',
        icon: faBacterium,
        description: 'Cholera Tuberculosis, Anthrax, Plague',
      },
      {
        case: 'Viral Other',
        icon: faVirus,
        description: 'HIV/AIDs, Hantaviruses, Lassa',
      },
    ],
  },
  {
    name: 'Event Cancellation',
    image: EventCancellationIcon,
    cases: [
      {
        case: 'Inclement Weather',
        icon: faCloudBolt,
        description:
          'Flood, Blizzard, Wildfire, Hurricane, Tornado, Earthquake, Heat Wave, Sinkhole or Air Pollution',
      },
      {
        case: 'Disease Outbreak',
        icon: faBiohazard,
        description: 'Declaration of high-morbidity Pandemic or Epidemic',
      },
      {
        case: 'Transportation Outage',
        icon: faTruckPlane,
        description:
          'Out of commission or inaccessible transport (i.e. roads, trains, flights)',
      },
    ],
  },
];

export const COVERAGE_PLAN = [
  { amount: 500, price: 5 },
  { amount: 1000, price: 10 },
  { amount: 2000, price: 20 },
  { amount: 5000, price: 30 },
  { amount: 10000, price: 50 },
];

export const DEFAULT_ICON = InteruptedUtilitiesIcon;

export enum DefaultCoverage {
  MonthlyPrice = 10,
  CoverageAmount = 1000,
  ChosenCoverageIndex = 1,
}

export const CATEGORIES_STORAGE_KEY = 'active-categories';
export const USER_STORAGE_KEY = 'identity';
